import { Context } from "@nuxt/types";
import { COOKIES } from "~/helpers/constants";
import { useCoveoStore } from "~/stores/coveo-store";

export default async function (context: Context) {
  const coveoStore = useCoveoStore();
  if (coveoStore.getTokenExpirationDate > Date.now()) return;
  try {
    const coveoVisitorId = context.app.$cookies.get(COOKIES.COVEO_VISITOR_ID);
    const response = await context.app.$vsf.$coveo.api.auth({
      name: coveoVisitorId,
    });
    const newCoveoToken = response?.[0]?.token;
    coveoStore.setAuthToken(newCoveoToken);
  } catch (error) {
    console.error("Error fetching initial settings:", error);
  }
}
